module.exports = __webpack_public_path__ + "static/media/11.71527d50.png";